import { render, staticRenderFns } from "./AttendanceTagSettings.vue?vue&type=template&id=173cf940"
import script from "./AttendanceTagSettings.vue?vue&type=script&lang=js"
export * from "./AttendanceTagSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports